const CAMPAIGN_HASH = window.location.pathname.substr(1);
const SHIPAY_BASE_URL = window.location.href;

export const STATES = ['AC','AL','AP','AM','BA','CE','DF','ES','GO','MA','MT','MS','MG','PA','PB','PR','PE','PI','RJ','RN','RS','RO','RR','SC','SP','SE','TO'];

export const getApiUrls = ()=> {
    if(window.location.hostname.includes('localhost')) {
        return {
            SHIPAY_TERMS_URL: `http://localhost:8080/api/get_service_terms/${CAMPAIGN_HASH}`,
            SHIPAY_LEAD_URL: `http://localhost:8080/api/lead_capture/${CAMPAIGN_HASH}`,
            SHIPAY_CEP_URL: `http://localhost:8080/api/get_address/${CAMPAIGN_HASH}`,
            SHIPAY_REGISTRATION_URL: `http://localhost:8080/api/send_form/${CAMPAIGN_HASH}`,
        };
    }
    const envMatch = window.location.hostname.match(/.+[\-](.*)\.shipay/);
    if(envMatch) {
        return {
            SHIPAY_TERMS_URL: `https://pdv-${envMatch[1]}.shipay.com.br/api/get_service_terms/${CAMPAIGN_HASH}`,
            SHIPAY_LEAD_URL: `https://pdv-${envMatch[1]}.shipay.com.br/api/lead_capture/${CAMPAIGN_HASH}`,
            SHIPAY_CEP_URL: `https://pdv-${envMatch[1]}.shipay.com.br/api/get_address/${CAMPAIGN_HASH}`,
            SHIPAY_REGISTRATION_URL: `https://pdv-${envMatch[1]}.shipay.com.br/api/send_form/${CAMPAIGN_HASH}`,
        };
    }
    else {
        return {
            SHIPAY_TERMS_URL: `https://pdv.shipay.com.br/api/get_service_terms/${CAMPAIGN_HASH}`,
            SHIPAY_LEAD_URL: `https://pdv.shipay.com.br/api/lead_capture/${CAMPAIGN_HASH}`,
            SHIPAY_CEP_URL: `https://pdv.shipay.com.br/api/get_address/${CAMPAIGN_HASH}`,
            SHIPAY_REGISTRATION_URL: `https://pdv.shipay.com.br/api/send_form/${CAMPAIGN_HASH}`,
        };
    }
}
